import { Button } from "@/components/ui/button";

export type ChannelFilter = "all" | "web" | "phone";

const FILTERS: { value: ChannelFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "web", label: "Video" },
  { value: "phone", label: "Telephone" },
];

interface ChannelToggleProps {
  value: ChannelFilter;
  onChange: (value: ChannelFilter) => void;
  disabled?: boolean;
}

const ChannelToggle = ({ value, onChange, disabled }: ChannelToggleProps) => (
  <div className="flex gap-1">
    {FILTERS.map((item) => (
      <Button
        key={item.value}
        size="sm"
        variant={value === item.value ? "default" : "outline"}
        disabled={item.value !== "all" && disabled}
        onClick={() => onChange(item.value)}
      >
        {item.label}
      </Button>
    ))}
  </div>
);

export default ChannelToggle;
